/* Rundis theme: newsletter popup. Once per visitor, after a delay or scroll depth. */
(() => {
  'use strict';
  const KEY = 'rundis:popup-seen';
  const store = {
    get() { try { return window.localStorage.getItem(KEY); } catch (e) { return '1'; } },
    set() { try { window.localStorage.setItem(KEY, '1'); } catch (e) { /* storage blocked */ } }
  };

  class NewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.dialog.addEventListener('close', () => store.set());
      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:select', (e) => { if (e.target.contains(this)) this.open(); });
        document.addEventListener('shopify:section:deselect', (e) => { if (e.target.contains(this)) this.dialog.close(); });
        return;
      }
      if (window.location.hash === `#${this.dataset.formId}`) { this.open(); return; }
      if (this.dataset.enabled !== 'true' || store.get()) return;
      const delay = (Number(this.dataset.delay) || 20) * 1000;
      const depth = (Number(this.dataset.scroll) || 50) / 100;
      this.timer = window.setTimeout(() => this.trigger(), delay);
      this.onScroll = () => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max >= depth) this.trigger();
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    trigger() {
      if (document.querySelector('dialog[open]')) {
        window.clearTimeout(this.timer);
        this.timer = window.setTimeout(() => this.trigger(), 5000);
        return;
      }
      window.clearTimeout(this.timer);
      window.removeEventListener('scroll', this.onScroll);
      this.open();
      store.set();
    }

    open() {
      if (window.Theme && window.Theme.openDialog) window.Theme.openDialog(this.dialog);
      else if (!this.dialog.open) this.dialog.showModal();
    }
  }
  if (!customElements.get('newsletter-popup')) customElements.define('newsletter-popup', NewsletterPopup);
})();
